import { dataCouponMinus } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCouponMinus = /*#__PURE__*/createIcon(dataCouponMinus)
export default IconCouponMinus
